export default __webpack_public_path__ + "static/media/GreenFrame07.2b2e5f3f.png";